import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext";


const API_BASE_URL = 'https://eleganzaestatesolutions.com/api';

const UserSetUpProfile = () => {
    const { setRole } = useAuth();

    const location = useLocation();
    const decodedUser = location.state?.decodedUser;

    const [formData, setFormData] = useState({
        firstName: decodedUser?.firstName || "",
        lastName: decodedUser?.lastName || "",
        email: decodedUser?.email || "",
        roleName: "user",
        phoneNumber: "",
        age: "",
        gender: "",
    });


    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${API_BASE_URL}/user/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log(result);

            if (response.ok && result.error === false) {
                console.log("Registration successful");

                localStorage.setItem("accessToken", result.meta.token);
                localStorage.setItem("role", result.meta.role);
                localStorage.setItem("user", JSON.stringify(result.user));
                setRole(result.meta.role);

                navigate("/");
            } else {
                setMessage(result.message || "Registration failed");
            }
        } catch (error) {
            console.error(error);
            setMessage("Registration failed");
        }
    };

    return (
        <>
            <div style={{ backgroundColor: "var(--bs-primary)" }}>

                <div className="container d-flex justify-content-center align-items-center min-vh-100  py-2">
                    <div
                        className="row border rounded-5 p-3 bg-white shadow box-area"
                        style={{
                            width: "1200px",
                            padding: "200px",
                            backgroundColor: "var(--bs-secondary)!important",
                        }}
                    >
                        <div
                            className="col-md-6 rounded-4 d-flex justify-content-center align-items-center flex-column left-box"
                            style={{
                                backgroundColor: " #122620",
                                padding: "3rem",
                                // backgroundColor: "var(--bs-primary)",
                            }}
                        >
                            <div className="featured-image mb-3">
                                <img
                                    src="../../assets/images/logo/logo coloured high quality-23 (1).png"
                                    className="img-fluid"
                                    style={{ width: "500px" }}
                                    alt="Logo"
                                />
                            </div>
                        </div>

                        <div className="col-md-6 right-box" style={{ padding: "40px" }}>
                            <div className="row align-items-center">
                                <div
                                    className="header-text mb-4"
                                    style={{ color: "var(--bs-primary)" }}
                                >
                                    <h2> Setup Profile</h2>
                                    <p>We are happy to have you here</p>
                                </div>
                                <Form onSubmit={handleRegister}>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="firstName">
                                                <Form.Label>First Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="firstName"
                                                    value={formData.firstName}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="lastName">
                                                <Form.Label>Last Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="lastName"
                                                    value={formData.lastName}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="email">
                                                <Form.Label style={{ marginTop: "10px" }}>
                                                    Email
                                                </Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="phoneNumber">
                                                <Form.Label style={{ marginTop: "10px" }}>
                                                    Phone Number
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="phoneNumber"
                                                    value={formData.phoneNumber}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="age">
                                                <Form.Label style={{ marginTop: "10px" }}>
                                                    Age
                                                </Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="age"
                                                    value={formData.age}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group controlId="gender">
                                                <Form.Label style={{ marginTop: "10px" }}>
                                                    Gender
                                                </Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="gender"
                                                    value={formData.gender}
                                                    onChange={handleInputChange}
                                                    required
                                                >
                                                    <option value="">Select Gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="other">Other</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Button variant="primary" type="submit" className="mt-3">
                                        Register
                                    </Button>
                                </Form>

                            </div>


                            {/* Message Display */}
                            {message && (
                                <div className="alert alert-info mt-3">{message}</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserSetUpProfile;
